import { EMAIL_REGEX } from '@/utils/emailRegex';
import { validateDateOfBirth } from '@/utils/validateDateOfBirth';
import { z } from 'zod';

function isValidPhoneNumber(phone: string): boolean {
  const cleaned = phone.replace(/\D/g, '');
  return cleaned.length === 10 || (cleaned.length === 11 && cleaned[0] === '1');
}

export const boaFormSchema = z.object({
  first_name: z.string().trim().min(1, 'First name is required'),
  last_name: z.string().trim().min(1, 'Last name is required'),
  email: z
    .string()
    .trim()
    .min(1, 'Email is required')
    .regex(EMAIL_REGEX, 'Enter a valid email'),
  phone: z
    .string()
    .trim()
    .min(1, 'Phone is required')
    .refine(isValidPhoneNumber, 'Enter a valid US phone number'),
  dob: z.string().superRefine((value, ctx) => {
    const error = validateDateOfBirth(value);
    if (error) ctx.addIssue({ code: 'custom', message: error });
  }),
  gender: z.string().min(1, 'Gender is required'),
  sms_opt_in: z.boolean().optional(),
});

export type BoaFormValues = z.infer<typeof boaFormSchema>;
